import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import { Button, Input, Popconfirm, message } from 'antd'
import styled from 'styled-components'
import { actions } from '../../redux/modules/templatesActions'
import { actions as tasksActions } from '../../redux/modules/tasksActions'
import RepairOrderEditor from '../../components/RepairOrderEditor'
import history from '../../history'
import _ from 'lodash'
import config from '../../config'

const { API_BASE } = config

const Container = styled.div`
  padding: 25px;
`
const MarginTop = styled.div`
  margin-top: 15px;
`
const propTypes = {}
const { TextArea } = Input

class TemplatesRepairOrder extends Component {
  constructor(props) {
    super(props)
    this.state = {
      currentKey: 'repair_order',
      currentId: +this.props.match.params.templateId,
      repairOrderItems: []
    }

    this.props.getTemplateById({
      templateType: this.state.currentKey,
      templateId: this.state.currentId
    })
    this.props.getAllTasks()
  }

  componentDidUpdate(prevProps) {
    if (this.props.templatesActions && this.props.templatesActions.loadedTemplate) {
      if (
        this.props.templatesActions.loadedTemplate !== prevProps.templatesActions.loadedTemplate
      ) {
        const loadedTemplate = this.props.templatesActions.loadedTemplate.template_info[0]
        const templateItems = this.props.templatesActions.loadedTemplate.template_tasks
        if (loadedTemplate) {
          this.setState({
            templateName: loadedTemplate.name,
            templateDescription: loadedTemplate.description,
            requestedBy: loadedTemplate.requested_by,
            repairOrderItems: templateItems
          })
        }
      }
    }
  }

  handleInputChange = (value, input) => {
    this.setState({ [input]: value })
  }

  handleCreate = () => {
    const {
      currentId,
      templateName,
      templateDescription,
      requestedBy,
      repairOrderItems
    } = this.state
    const data = {
      requested_by: requestedBy,
      description: templateDescription,
      name: templateName,
      estimate_template_id: currentId,
      tasks: repairOrderItems
    }
    if (currentId === 0) {
      this.props.createTemplate({
        templateType: 'repair_order',
        content: data,
        userId: this.props.authentication.user.userId
      })
    } else {
      this.props.saveTemplate({
        templateId: this.state.currentId,
        templateType: 'repair_order',
        content: data,
        userId: this.props.authentication.user.userId
      })
    }

    message.success('Changes saved.')
    this.setState({ contentData: null, currentId: 0, modalVisible: false })
  }

  confirmDelete = () => {
    this.props.deleteTemplate({
      templateId: this.state.currentId,
      templateType: 'repair_order'
    })

    message.success('Record deleted.')
    this.setState({
      contentData: null,
      currentId: 0,
      modalVisible: false
    })
  }

  handleItemsChange = repairOrderItems => {
    this.setState({
      repairOrderItems
    })
  }

  handleItemInputChange = (value, key, column) => {
    const groupedItems = this.state.repairOrderItems.map(row => {
      if (row.id === key) row[column] = value
      return row
    })
    this.setState({
      repairOrderItems: groupedItems
    })
  }

  editChangeOrderRow = rowId => {
    const groupedItems = this.state.repairOrderItems.map(row => {
      if (row.id === rowId) row.isEditingRow = true
      return row
    })
    this.setState({
      repairOrderItems: groupedItems
    })
  }

  saveChangeOrderRow = rowId => {
    const groupedItems = this.state.repairOrderItems.map(row => {
      if (row.id === rowId) {
        row.isEditingRow = false
      }
      return row
    })
    this.setState({
      repairOrderItems: groupedItems
    })
  }

  deleteChangeOrderRow = rowId => {
    const groupedItems = this.state.repairOrderItems.filter(item => item.id !== rowId)

    this.setState({
      repairOrderItems: groupedItems
    })
  }

  handleAddTaskInputChange = value => {
    this.setState({
      addTaskInput: value
    })

    const selectedTask = this.props.tasksActions.allTasks.data.filter(
      row => parseInt(row.id, 0) === parseInt(value, 0)
    )
    if (selectedTask.length > 0) {
      this.setState({
        addTaskName: selectedTask[0].name
      })
    }
  }

  handleAddDeviceNumberInputChange = value => {
    this.setState({
      addDeviceNumberInput: value
    })
  }

  handleAddMaterialsNeededInputChange = value => {
    this.setState({
      addMaterialsNeededInput: value
    })
  }

  handleAddNotesInputChange = value => {
    this.setState({
      addNotesInput: value
    })
  }

  handleAddItemClick = () => {
    const groupedItems = this.state.repairOrderItems
    if (
      _.isEmpty(this.state.addTaskInput) ||
      _.isEmpty(this.state.addDeviceNumberInput) ||
      _.isEmpty(this.state.addMaterialsNeededInput) ||
      _.isEmpty(this.state.addNotesInput)
    ) {
      message.warning('You need to fill all item informations.')
    } else {
      let selectedTaskName = null
      let selectesTaskId = null
      if (_.isEmpty(this.state.addTaskName)) {
        const selectedTask = this.props.tasksActions.allTasks.data.filter(
          row => row.name === this.state.addTaskInput
        )

        if (selectedTask.length > 0) {
          selectedTaskName = selectedTask[0].name
          selectesTaskId = selectedTask[0].id
          this.setState({
            addTaskName: selectedTask[0].name
          })
        }
      }

      groupedItems.push({
        task_id: selectesTaskId || this.state.addTaskInput,
        task_name: selectedTaskName || this.state.addTaskName,
        device_number: this.state.addDeviceNumberInput,
        notes: this.state.addNotesInput,
        materials_needed: this.state.addMaterialsNeededInput,
        id: groupedItems.length + 1
      })

      this.setState({
        repairOrderItems: groupedItems,
        addTaskInput: '',
        addTaskName: '',
        addDeviceNumberInput: '',
        addNotesInput: '',
        addMaterialsNeededInput: ''
      })
    }
  }

  handleTemplateChange = event => {
    const form = this.props.form
    const selectedTemplate = this.props.repairOrderTemplatesActions.repairOrderTemplates.data.filter(
      row => parseInt(row.id, 0) === parseInt(event, 0)
    )
    if (selectedTemplate.length > 0) {
      this.props.getRepairOrderTemplateItems(selectedTemplate[0].id)
      form.setFieldsValue({
        description: selectedTemplate[0].description,
        repair_order_template_id: selectedTemplate[0].id
      })
    }
  }

  markTaskComplete = taskId => {
    this.props.markTaskComplete({
      jobId: this.props.jobId,
      taskId: taskId,
      repairOrderId: this.state.currentId
    })
  }

  handleQuickAddTask = task => {
    this.props.mainQuickAddTask({
      task: task,
      userId: this.props.authentication.user.userId
    })
  }

  render() {
    return (
      <Container>
        <h2>Repair Order Template</h2>
        <div className="row">
          <div className="col-md-12">
            <div>Template</div>
            <Input
              value={this.state.templateName}
              onChange={event => this.handleInputChange(event.target.value, 'templateName')}
            />
          </div>
        </div>
        <div>Description</div>
        <TextArea
          placeholder="Type in description..."
          rows={4}
          onChange={event => this.handleInputChange(event.target.value, 'templateDescription')}
          value={this.state.templateDescription}
        />
        <div className="row">
          <div className="col-md-12">
            <MarginTop>
              {this.state.currentId > 0 && (
                <Fragment>
                  <Popconfirm
                    title="Are you sure you want to delete this record?"
                    onConfirm={this.confirmDelete}
                    onCancel={this.cancelDelete}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Button type="danger" icon="delete" className="mr-2" />
                  </Popconfirm>
                  <a
                    href={`${API_BASE}/api/templates/repair_order/id/${this.state.currentId}/print`}
                    target="_blank"
                  >
                    <Button icon="printer" className="mr-2" />
                  </a>
                </Fragment>
              )}
            </MarginTop>
          </div>
        </div>
        <RepairOrderEditor
          allTasks={
            this.props.tasksActions &&
            this.props.tasksActions.allTasks &&
            this.props.tasksActions.allTasks.data
          }
          repairOrderItems={this.state.repairOrderItems}
          handleItemsChange={this.handleItemsChange}
          editRow={this.editChangeOrderRow}
          saveRow={this.saveChangeOrderRow}
          deleteRow={this.deleteChangeOrderRow}
          handleAddTaskInputChange={this.handleAddTaskInputChange}
          handleAddDeviceNumberInputChange={this.handleAddDeviceNumberInputChange}
          handleAddMaterialsNeededInputChange={this.handleAddMaterialsNeededInputChange}
          handleAddNotesInputChange={this.handleAddNotesInputChange}
          handleAddItemClick={this.handleAddItemClick}
          handleInputChange={this.handleItemInputChange}
          addTaskInput={this.state.addTaskInput}
          addTaskName={this.state.addTaskName}
          addDeviceNumberInput={this.state.addDeviceNumberInput}
          addMaterialsNeededInput={this.state.addMaterialsNeededInput}
          addNotesInput={this.state.addNotesInput}
          isNew
          markTaskComplete={this.markTaskComplete}
          handleQuickAddTask={this.handleQuickAddTask}
        />
        <MarginTop>
          <Button onClick={() => history.goBack()}>Cancel</Button>{' '}
          <Button type="primary" onClick={() => this.handleCreate()}>
            {this.state.currentId === 0 && <span>Create Template</span>}
            {this.state.currentId > 0 && <span>Save Changes</span>}
          </Button>
        </MarginTop>
      </Container>
    )
  }
}

const mapStateToProps = ({ templatesActions, tasksActions, authentication }, ownProps) => ({
  templatesActions,
  tasksActions,
  authentication
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(Object.assign({}, actions, tasksActions), dispatch)
})

TemplatesRepairOrder.propTypes = propTypes
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TemplatesRepairOrder))



// WEBPACK FOOTER //
// ./src/containers/templates/repairOrderTemplate.js